import {
  get_px8ok5q0jdway2 as get_px,
  plus2opbwe063z9pg as plus,
} from './data.commonHtml.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  times2ukvaf6yk96p2 as times,
  divkhq3vjih9fcw as div,
  Dimension__toString_impl_o4q1ad26wkwcghhu2zh as Dimension__toString_impl_o4q1ad,
  Dimension__hashCode_impl_p583vw23xta4b9uvomj as Dimension__hashCode_impl_p583vw,
} from './data.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ZERO_1 = Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(get_px(0));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var EdgesClass;
function Edges() {
  if (EdgesClass === VOID) {
    class $ {
      constructor(left, top, right, bottom) {
        return new.target.new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(left, top, right, bottom);
      }
      static new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(left, top, right, bottom) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.left_1 = left;
        $this.top_1 = top;
        $this.right_1 = right;
        $this.bottom_1 = bottom;
        return $this;
      }
      static new_com_lightningkite_kiteui_models_Edges_1f8j9i_k$(horizontal, vertical) {
        Companion_getInstance();
        return this.new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(horizontal, vertical, horizontal, vertical);
      }
      static new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(dimension) {
        Companion_getInstance();
        return this.new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(dimension, dimension, dimension, dimension);
      }
      plus_dihzqn_k$(other) {
        return Edges().new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(plus(this.left_1, other.left_1), plus(this.top_1, other.top_1), plus(this.right_1, other.right_1), plus(this.bottom_1, other.bottom_1));
      }
      plusEdgesNullable(other) {
        return other == null ? this : this.plus_dihzqn_k$(other);
      }
      times_kr2a3y_k$(other) {
        return Edges().new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(times(this.left_1, other), times(this.top_1, other), times(this.right_1, other), times(this.bottom_1, other));
      }
      div_fxyyjd_k$(other) {
        return Edges().new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(div(this.left_1, other), div(this.top_1, other), div(this.right_1, other), div(this.bottom_1, other));
      }
      toString() {
        return 'Edges(left=' + Dimension__toString_impl_o4q1ad(this.left_1) + ', top=' + Dimension__toString_impl_o4q1ad(this.top_1) + ', right=' + Dimension__toString_impl_o4q1ad(this.right_1) + ', bottom=' + Dimension__toString_impl_o4q1ad(this.bottom_1) + ')';
      }
      hashCode() {
        var result = Dimension__hashCode_impl_p583vw(this.left_1);
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.top_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.right_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.bottom_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Edges()))
          return false;
        if (!equals(this.left_1, other.left_1))
          return false;
        if (!equals(this.top_1, other.top_1))
          return false;
        if (!equals(this.right_1, other.right_1))
          return false;
        if (!equals(this.bottom_1, other.bottom_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Edges');
    EdgesClass = $;
  }
  return EdgesClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.Zero_1 = new (Rect())(0.0, 0.0, 0.0, 0.0);
      }
      fromSize_jwt73p_k$(left, top, width, height) {
        return new (Rect())(left, top, left + width, top + height);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var RectClass;
function Rect() {
  if (RectClass === VOID) {
    class $ {
      constructor(left, top, right, bottom) {
        Companion_getInstance_0();
        this.left_1 = left;
        this.top_1 = top;
        this.right_1 = right;
        this.bottom_1 = bottom;
      }
      get_size_woubt6_k$() {
        return new (Size())(this.get_width_j0q4yl_k$(), this.get_height_e7t92o_k$());
      }
      get_centerX_c9mbwa_k$() {
        return (this.left_1 + this.right_1) / 2;
      }
      get_centerY_c9mbwb_k$() {
        return (this.top_1 + this.bottom_1) / 2;
      }
      get_width_j0q4yl_k$() {
        return this.right_1 - this.left_1;
      }
      get_height_e7t92o_k$() {
        return this.bottom_1 - this.top_1;
      }
      copy_afmpo5_k$(left, top, right, bottom) {
        return new (Rect())(left, top, right, bottom);
      }
      toString() {
        return 'Rect(left=' + this.left_1 + ', top=' + this.top_1 + ', right=' + this.right_1 + ', bottom=' + this.bottom_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.left_1);
        result = imul(result, 31) + getNumberHashCode(this.top_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.right_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.bottom_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Rect()))
          return false;
        if (!equals(this.left_1, other.left_1))
          return false;
        if (!equals(this.top_1, other.top_1))
          return false;
        if (!equals(this.right_1, other.right_1))
          return false;
        if (!equals(this.bottom_1, other.bottom_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Rect');
    RectClass = $;
  }
  return RectClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.Zero_1 = new (Size())(0.0, 0.0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var SizeClass;
function Size() {
  if (SizeClass === VOID) {
    class $ {
      constructor(width, height) {
        Companion_getInstance_1();
        this.width_1 = width;
        this.height_1 = height;
      }
      copy_6r5gqz_k$(width, height) {
        return new (Size())(width, height);
      }
      copy$default_q06iir_k$(width, height, $super) {
        width = width === VOID ? this.width_1 : width;
        height = height === VOID ? this.height_1 : height;
        return $super === VOID ? this.copy_6r5gqz_k$(width, height) : $super.copy_6r5gqz_k$.call(this, width, height);
      }
      toString() {
        return 'Size(width=' + this.width_1 + ', height=' + this.height_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.width_1);
        result = imul(result, 31) + getNumberHashCode(this.height_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Size()))
          return false;
        if (!equals(this.width_1, other.width_1))
          return false;
        if (!equals(this.height_1, other.height_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Size');
    SizeClass = $;
  }
  return SizeClass;
}
//region block: exports
export {
  Edges as Edges2jf5wl855ambv,
  Size as Size2b01934yxlz5f,
  Companion_getInstance as Companion_getInstance252uiobns9yoh,
  Companion_getInstance_0 as Companion_getInstance1vsa8jrdqad0h,
  Companion_getInstance_1 as Companion_getInstance37y5uk6rnmz38,
};
//endregion

//# sourceMappingURL=Rect.mjs.map
